import React from 'react';

import Button from '@hero/ui-kit/inputs/Button';
import P from '@hero/ui-kit/typography/P';

import * as styles from './style.module.css';

type Props = {
    reason: string | null;
    onRetry: () => void;
};

const labelForReason = (reason: string | null): string => {
    switch (reason) {
        case 'redshift_unavailable':
            return 'Diagnostics database is unreachable.';
        case 'redshift_timeout':
            return 'Diagnostics database timed out.';
        default:
            return 'Diagnostics are temporarily unavailable.';
    }
};

const UnavailableBanner: React.FC<Props> = ({ reason, onRetry }) => (
    <div className={styles.unavailableBanner}>
        <P>{labelForReason(reason)} You can retry in a moment.</P>
        <Button onClick={onRetry}>Retry</Button>
    </div>
);

export default UnavailableBanner;
